export const firebaseConfig = {
  apiKey: "AIzaSyC5aYS6XOZke8_sLXPj7FPyjsFN5UnPC3o",
  authDomain: "bacpac-a46ca.firebaseapp.com",
  databaseURL: "https://bacpac-a46ca-default-rtdb.firebaseio.com",
  projectId: "bacpac-a46ca",
  storageBucket: "bacpac-a46ca.appspot.com",
  messagingSenderId: "1015430556133",
  appId: "1:1015430556133:web:8ac52306020bc9d5f5a70c",
  measurementId: "G-EVPS5XQPFW",
};

export const prodFirebaseConfig = {
  apiKey: "AIzaSyAcBYduYyiErCAU-aR1l1WD4AJXwaZk15I",
  authDomain: "best-painguide.firebaseapp.com",
  databaseURL: "https://best-painguide-default-rtdb.firebaseio.com",
  projectId: "best-painguide",
  storageBucket: "best-painguide.appspot.com",
  messagingSenderId: "462784951629",
  appId: "1:462784951629:web:f9a462c3601fb3fce97304",
  measurementId: "G-4FJKGQYWQG",
};
